import { validateEnvVariable } from './helpers';

const FIREBASE_API_KEY = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_API_KEY
);
const FIREBASE_AUTH_DOMAIN = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
);
const FIREBASE_PROJECT_ID = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_PROJECT_ID
);
const FIREBASE_STORAGE_BUCKET = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
);
const FIREBASE_MESSAGING_SENDER_ID = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID
);
const FIREBASE_APP_ID = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_APP_ID
);
const FIREBASE_MEASUREMENT_ID = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
);
const FIREBASE_VAPID_KEY = validateEnvVariable(
  import.meta.env.VITE_FIREBASE_VAPID_KEY
);

const firebaseEnvironment = {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_VAPID_KEY,
};

export default firebaseEnvironment;
